import { gql } from '@apollo/client';

const confirmSubComms = gql`
  mutation confirmSubComms($ticket: String!) {
    confirmSubComms(ticket: $ticket)
  }
`;

export default confirmSubComms;
